import { Modal } from '@procurify/ui'
import { useIntl } from 'react-intl'

import messages from './messages'
import { type ITaxFormProps, TaxForm } from './TaxForm'

export interface ITaxFormModalProps extends ITaxFormProps {
  open?: boolean
  onDismiss?: () => void
}

export const TaxFormModal = ({
  open = false,
  onDismiss = () => undefined,
  ...taxFormProps
}: ITaxFormModalProps) => {
  const intl = useIntl()

  return (
    <Modal
      aria-labelledby='taxForm-modal-title'
      maxWidth='sm'
      open={open}
      onClose={onDismiss}
      disableEnforceFocus
    >
      <Modal.Card>
        <Modal.Header id='taxForm-modal-title' onClose={onDismiss}>
          {intl.formatMessage(messages.modalHeader)}
        </Modal.Header>
        <Modal.Content>
          <TaxForm onCancel={onDismiss} {...taxFormProps} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}

TaxFormModal.displayName = 'TaxFormModal'
